export const translations = {
  en: {
    AboutHeroTitle: "Who We Are",
    AboutModelTitle: "Our Vision",
    AboutPageTitle: "About Talkmate AI",
    AboutTalkMateTitle: "What is TalkMate?",
    Active: "Active",
    ActiveAgents: "Active agents",
    AddAProject: "Add a project",
    AddComment: "Add comment",
    AddNewTicket: "Add a ticket",
    AddProject: "Add a project",
    AdminComment: "Admin comment",
    AdminNoProjectsYet: "No projects yet",
    Agent: "Agent",
    AgentContext: "Context & persona",
    AgentContextHelp:
      "We use this so the agent answers like your business: tone, key info, and what to avoid.",
    AgentDescription: "Short description",
    AgentName: "Agent name",
    AgentNameHelp: "Give your assistant a short, memorable name. You can change it later.",
    AgentPresentationLabel: "Agent Presentation to Client",
    AgentTone: "Tone",
    AgentToneHelp: "Pick a tone that fits your brand. You can adjust later.",
    AgentWebsite: "Website URL",
    AgentWebsiteHelp:
      "Paste your site URL; we'll pull key info to prefill your agent automatically.",
    Agents: "Agents",
    AgentsLimitHelper: "Limit: {max} agents",
    AgentsLimitReached: "Free plan limit reached ({max} agents).",
    All: "All",
    AllSubscriptions: "All subscriptions",
    AlreadyMemberOfACompany: "This user already belongs to a company",
    Analytics: "Analytics",
    AreYouSureToDeleteTicket: "Are you sure you want to delete this ticket ?",
    AttachedFiles: "ATTACHED FILES",
    AttachmentsSaved: "Attachments saved",
    AvailableOnPremium: "Available on Premium",
    Back: "Back",
    Billing: "Billing",
    Brand: "Talkmate",
    Branding: "Branding",
    Bug: "Bug",
    Cancel: "Cancel",
    CancelNow: "Cancel at period end",
    CancelScheduled: "Cancellation scheduled",
    CancelSubscription: "Cancel subscription",
    ChangeRequest: "Change request",
    Channels: "Channels",
    ChooseAProject: "Choose a project",
    ClearReadNotifications: "Clear read notifications",
    ClickToActivate: "Click to activate",
    ClickToDeactivate: "Click to deactivate",
    Close: "Close",
    Closed: "Closed",
    ComingSoon: "Coming Soon",
    CommaSeparated: "Comma Separated",
    Company: "Company",
    CompleteYourProfile: "What is the name of your company?",
    Confirm: "Confirm",
    ConfirmDeleteTicket: "Are you sure you want to delete this ticket ?",
    ConfirmLogout: "Confirm logout?",
    ContactAdminsAt: "Please contact the admin at",
    ContactUs: "Contact us",
    ContinueWithoutEmail: "Continue without email",
    Conversations: "Conversations",
    ConversationsToday: "Conversations today",
    Create: "Create",
    CreateAgent: "Create your agent",
    CreatedAt: "CREATED AT",
    Creator: "Created by",
    CurrentMonthTicketsCount: "Tickets created this month: {count}/40.",
    CurrentPlanLabel: "Your current plan",
    Customer: "Customer",
    DarkModeOff: "Dark Mode Off",
    DarkModeOn: "Dark Mode On",
    Dashboard: "Dashboard",
    Delete: "Delete",
    DeleteAgentTitle: "Delete agent",
    DeleteTicket: "Delete Ticket",
    Deleting: "Deleting…",
    DetailComingSoon: "We are working on it",
    Done: "Done",
    DragAndDropOrBrowse: "Drag and Drop or Browse file",
    Edit: "Edit",
    EditPicture: "Edit Picture",
    EditProfile: "Profile details",
    EditProject: "Edit project",
    EmailAddress: "Email address",
    EmailAlreadyExists: "This email has already been used to send an invite",
    EmailAlreadyInvited: "This email has already been invited",
    EmailOptional: "Your email (required to start)",
    ErrorDeletingTicket: "Error when deleting ticket:",
    Evolution: "Improvement",
    FailedToAddTicket: "Failed to add ticket",
    FailedToUpdateTicket: "Failed to update ticket",
    Feature: "Feature",
    FeatureEase: "Unlimited agent creation in just minutes",
    FeaturePremiumValue: "Pay only for the number of questions asked",
    FeatureZeroCost: "10 free questions to try your AI agent",
    FreePlanFeature1: "Test an agent with up to 10 questions",
    FreePlanFeature2: "Basic access to TalkMate features",
    FreePlanFeature3: "Share link with customers",
    FreePlanProjectLimit: "On the Free plan you can create only 1 project.",
    FreePlanTitle: "Free Plan",
    GetStartedByCreatingProject: "Get started by creating a project",
    GoPremium: "Go Premium",
    GoToDashboard: "Go to Dashboard",
    HelpCenterSubtitle: "Everything you need to make the most of TalkMate",
    HelpCenterTitle: "Help & Resources",
    HelpFAQs: "Help & FAQs",
    HeroHighlight: "personalized",
    HeroTitleFull: "Create your own AI Agents for your business",
    HeroTitlePart1: "Your business,",
    HeroTitlePart2: "your AI agents",
    High: "High",
    Improvement: "Improvement",
    InProduction: "In production",
    InReview: "In review",
    InStaging: "In staging",
    InTest: "In test",
    Inactive: "Inactive",
    Incident: "Incident",
    InitializingChat: "Initializing chat...",
    ChatEmailHint: "Enter your email to start chat with our agent.",
    Integrations: "Integrations",
    IntegrationsMetric: "Integrations",
    Interactions: "Interactions",
    InvalidEmail: "Please enter a valid email address",
    InviteByEmail: "Invit a user by email",
    InviteFailed: "Failed to send invitation",
    InviteSent: "Invite sent",
    InviteUser: "Invite a user",
    JoinedOn: "Joined On",
    Landing_BenefitsBanner: "Always available 24/7 • All languages • Instant answers • Natural language • No more instant replies by your team",
    Landing_CTAPrimary: "Create your first agent for free",
    Landing_FreeTrialLine: "Try free: 1 agent included, up to 10 questions",
    Landing_HeroSubtitle1: "Online, on your site, or via a simple link.",
    Landing_HeroSubtitle2: "It answers recurring questions for your team. Instant. 24/7.",
    Landing_HeroTitle: "Create your AI agent that answers your customers automatically",
    Landing_HowStep1Desc: "Say what your business does and your key info.",
    Landing_HowStep1Title: "1. Describe your context",
    Landing_HowStep2Desc: "Ask questions and adjust in seconds.",
    Landing_HowStep2Title: "2. Test live",
    Landing_HowStep3Desc: "Embed the widget or share a simple link.",
    Landing_HowStep3Title: "3. Share everywhere",
    Landing_HowTitle: "How it works",
    Landing_RealEstateMsg1Client: "Where exactly is the apartment on Victor-Hugo street?",
    Landing_RealEstateMsg2Agent: "5 minutes from the metro and close to shops. The exact address is in the listing.",
    Landing_RealEstateMsg3Client: "Is there parking and which charges are included?",
    Landing_RealEstateMsg4Agent: "Parking optional. Water included, electricity not included. Details in the description.",
    Landing_RealEstateTitle: "Real-estate Assistant — Live property info",
    Landing_RestaurantMsg1Client: "Hi, what are your opening hours today?",
    Landing_RestaurantMsg2Agent: "We are open 12–2 PM and 7–10 PM.",
    Landing_RestaurantMsg3Client: "Do you have vegetarian options on the menu?",
    Landing_RestaurantMsg4Agent: "Yes—for example a quinoa salad and a veggie curry. See our full menu.",
    Landing_RestaurantTitle: "Restaurant Assistant — Instant FAQ",
    Landing_ValueCard1Desc: "1 agent included, up to 10 questions.",
    Landing_ValueCard1Title: "Try it in 2 minutes",
    Landing_ValueCard2Desc: "Premium later: unlimited agents, pay per volume.",
    Landing_ValueCard2Title: "No card, no commitment",
    LatestSupportTickets: "Latest Support Tickets",
    Loading: "Loading…",
    LoadingUsers: "Loading users...",
    LogInWithGoogle: "Log in with Google",
    Logout: "Log out",
    Low: "Low",
    ManageAndMonitorAgents: "Create, configure and monitor your AI agents",
    ManageFile: "Manage file(s)",
    ManageSubscription: "Manage subscription",
    MaxFileSize: "Max file size : ",
    Medium: "Medium",
    MissingFields: "MISSING FIELDS",
    MonthlyRevenueEst: "Monthly revenue (est.)",
    MonthlyRevenueHint: "Based on {count} premium accounts at $15/mo.",
    MonthlyUsage: "Monthly usage",
    MustBeActiveUser: "You must be an active user to perform this action",
    MyTickets: "My agents",
    NavOffer: "Our Offer",
    NewMessages: "New messages",
    NewsletterCta: "Subscribe",
    NewsletterEmailPlaceholder: "Enter your email to stay updated",
    NewsletterInvalidEmail: "Please enter a valid email address.",
    NewsletterSaveFailed: "Failed to save your subscription, please try again.",
    NewsletterSubmitting: "Subscribing…",
    NewsletterThanks: "Thank you! You are now subscribed.",
    Next: "Next",
    NoActivityYet: "No Activity Yet",
    NoAgentsYet: "No agents yet — click the + button to create one",
    NoColleagues: "No team member for the moment",
    NoEmail: "No email",
    NoHistory: "No historical usage",
    NoMemberToAdd: "No member to add : Go to profil and invite user to join",
    NoNotifications: "No notifications",
    NoProjectNorma: "No project for the moment →",
    NoProjectNormal: "No project for the moment →",
    NoProjectSelected: "No project selected",
    NoProjects: "No project for the moment",
    NoTicketsInTab: "No tickets on this status for this project",
    NoTicketsInTabMessage: "Select another tab to see if there is ticket",
    NoUsersFound: "No users found",
    OfMonthlyBudget: "of monthly available capacity",
    OnlyCreatorCanEdit: "Only the creator or an admin can edit this ticket",
    OnlyOneProjectOnFree: "Only 1 project allowed on the Free plan.",
    Open: "Open",
    OptionalMessage: "Optional Message",
    OverviewTitle: "Overview",
    PageConcerned: "CONCERNED ELEMENT",
    PageListCategories: "Pages list categories",
    PaymentCanceledMessage: "The payment was canceled. You can try again.",
    PaymentCanceledTitle: "Payment canceled",
    PaymentSuccessMessage: "Your Premium subscription is now active.",
    PaymentSuccessTitle: "Payment successful",
    Pending: "Pending",
    PhotoUploadFailed: "Failed to upload photo",
    PlanBasicAgents: "Basic: 3 agents",
    PlanBasicTokens: "Basic: 200k tokens",
    PlanDetailsBasic: "Basic: 3 agents / 200k tokens per month.",
    PlanDetailsPremium: "Premium: 15 agents / 2M tokens per month.",
    PlanFreeHint: "Free plan: up to 3 agents / 200k tokens per month.",
    PlanFreeLabel: "Basic plan",
    PlanNoneLabel: "No tenant",
    PlanPremiumAgents: "Premium: 15 agents",
    PlanPremiumHint: "Premium: up to 15 agents / 2M tokens per month.",
    PlanPremiumLabel: "Premium plan",
    PlanPremiumTokens: "Premium: 2M tokens",
    PlanUnknownLabel: "Unknown",
    PlanUpgradeCTA: "Go Premium",
    PleaseFillYourCompanyName: "Please fill your company name",
    PleaseFillYourCompanyNameFirst: "Fill your company name first",
    PleaseSendTicket: "Please submit a ticket",
    PostComment: "Post comment",
    PremiumBadge: "Premium workspace",
    PremiumBadgeSubtitle: "Unlock the full Talkmate automation suite",
    PremiumFeature1Title: "Unlimited branded agents",
    PremiumFeature2Desc: "",
    PremiumFeature2Title: "Advanced automations",
    PremiumFeature3Desc: "",
    PremiumFeature3Title: "Deep analytics",
    PremiumFeature4Desc: "Widget, public URL, iframe for modern teams.",
    PremiumFeature4Title: "Share & embed everywhere",
    PremiumFeature5Desc: "",
    PremiumFeature5Title: "Enterprise control",
    PremiumFeature6Desc: "",
    PremiumFeature6Title: "Priority success team",
    PremiumFeaturesEyebrow: "Capabilities",
    PremiumHeroCTA: "Upgrade now",
    PremiumHeroTalkToSales: "Talk to sales",
    PremiumHeroTitle: "Unlock unlimited agents with enterprise control",
    PremiumPageTitle: "Premium workspace",
    PremiumPlanCardTitle: "What you unlock with Premium",
    PremiumPlanFeature1: "Usage-based pricing by question",
    PremiumPlanFeature2: "Unlimited agents and channels",
    PremiumPlanFeature3: "Analytics, conversation history, and email alerts",
    PremiumPlanFeature4: "Custom branding for your chat widget",
    PremiumPlanIncluded1: "Unlimited AI agents & share links",
    PremiumPlanIncluded2: "",
    PremiumPlanIncluded3: "Access to GPT-4o",
    PremiumPlanIncluded4: "",
    PremiumPlanIncluded5: "Conversation history",
    PremiumPlanIncluded6: "",
    PremiumPlanPrice: "$15",
    PremiumPlanPriceSuffix: "/mo",
    PremiumPlanTitle: "Pay-as-you-grow",
    PremiumStat1Label: "Widgets, share links & API",
    PremiumStat1Value: "Unlimited",
    PremiumStat2Label: "Time saved on repetitive chats",
    PremiumStat2Value: "-70%",
    PremiumStat3Label: "Lead capture & customer care",
    PremiumStat3Value: "24/7",
    PremiumWorkflow1Title: "Set the context for each agent",
    PremiumWorkflow2Title: "Test and add guardrails",
    PremiumWorkflow3Title: "Publish everywhere",
    PremiumWorkflowTitle: "Launch in days, not months",
    PreviousMonths: "Previous months",
    Price: "Price",
    Pricing: "Pricing",
    PricingPageTitle: "Talkmate Pricing – Free vs. Premium",
    PricingPlansTitle: "Our Plans",
    PricingSubtitle: "Start free. Scale when you need more power.",
    PricingTitle: "Pricing Plans",
    Priority: "PRIORITY",
    PriorityChanged: "Priority changed",
    PriorityError: "Priority",
    PriorityForm: "Priority",
    PrivacyPolicy: "Privacy Policy",
    PrivacyPolicyTitle: "Privacy Policy",
    Problem: "Problem",
    Profile: "Profile",
    Project: "PROJECT",
    ProjectCreated: "Project created",
    ProjectDeletedConfirm: "Are you sure you want to delete this project?",
    ProjectMembers: "Project members",
    ProjectName: "Project name",
    ProjectUpdated: "Project updated successfully",
    Projects: "Projects",
    ProjectsList: "PROJECTS LIST",
    Question: "Question",
    QuestionsThisMonth: "Questions this month",
    QuestionsUsed: "Questions used",
    RecentAgents: "Recent agents",
    RemainingCredits: "Remaining credits",
    RemoveLogo: "Remove logo",
    RenewSubscription: "Renew subscription",
    RequiredField: "Required field",
    Reset: "Reset",
    ResetTest: "Reset test",
    RoleUpdateFailed: "Failed to update role",
    RoleUpdated: "Role updated successfully",
    Save: "Save",
    SaveAttachments: "Save attachments",
    SearchPlaceholder: "Search…",
    SearchTicketsPlaceholder: "Search tickets (title, description, number)…",
    Select: "Select",
    SelectMembers: "Select member(s)",
    SelectProject: "Please select a project",
    SelectTone: "Select tone",
    Send: "Send",
    SendAMessage: "Send a message",
    SendEmail: "Send email",
    SendInvite: "Send the invit",
    SignIn: "Sign In",
    Signout: "Sign Out",
    Start: "Start",
    Status: "STATUT",
    StatusChangedClosed: "Status → Closed",
    StatusChangedOpen: "Status → Open",
    Subscription: "Subscription",
    SubscriptionCanceledTitle: "Subscription canceled",
    SuccessfullyLoggedInWithGoogle: "Successfully Logged In With Google",
    Suggestion: "Suggestion",
    SuperAdminSubtitle: "All users, roles, and token consumption",
    SuperAdminTitle: "Super Admin",
    SupportTickets: "Support Tickets",
    Task: "Task",
    TeamMembers: "TEAM MEMBER(S)",
    TestChat: "Test chat",
    ThisMonth: "This month",
    TicketActivity: "Ticket activity",
    TicketAddedSuccessfully: "Ticket added successfully",
    TicketCreated: "Ticket created",
    TicketInsights: "Ticket Insights",
    TicketName: "TICKET NAME",
    TicketNameError: "Ticket name",
    TicketNameForm: "Ticket name",
    TicketNumber: " # Ticket",
    TicketSuccessfullyDeleted: "Ticket successfully deleted",
    TicketType: "TICKET TYPE",
    TicketTypeError: "Ticket type",
    TicketUpdatedSuccessfully: "Ticket updated successfully",
    TierFreeButton: "Try for free",
    TierFreeFeature1: "1 test AI agent",
    TierFreeFeature2: "200,000 tokens offered",
    TierFreeFeature3: "Basic context setup",
    TierFreeFeature4: "Public link to share",
    TierFreeFeature5: "Community support",
    TierFreeName: "Free",
    TierFreePrice: "0",
    TierPremiumButton: "Upgrade to Premium",
    TierPremiumFeature1: "Unlimited AI agents",
    TierPremiumFeature2: "Pay only per question asked",
    TierPremiumFeature3: "Access to advanced models (GPT-4o & GPT-4.1)",
    TierPremiumFeature4: "Conversation history & analytics",
    TierPremiumFeature5: "Custom branding & integrations",
    TierPremiumFeature6: "Priority support",
    TierPremiumName: "Premium",
    TierPremiumPrice: "20",
    Tokens: "Tokens used",
    TokensLimitHelper: "Monthly quota: {max}",
    ToneConcise: "Concise",
    ToneEmpathetic: "Empathetic",
    ToneFriendly: "Friendly",
    ToneLabel: "Tone",
    ToneNeutral: "Neutral",
    TonePlayful: "Playful",
    ToneProfessional: "Professional",
    ToneSupportive: "Supportive",
    ToneTechnical: "Technical",
    TotalTokensAllTenants: "Total tokens (all tenants)",
    TotalTokensUsed: "Tokens used",
    TryAgain: "Try again",
    TryAnotherProjectOrTab: "Select/add a projet on the top or change tab",
    Type: "TYPE",
    UnreadConversations: "Unread conversations",
    UpdateTicket: "Update Ticket",
    UploadFiles: "Upload file(s)",
    UploadLogo: "Upload logo",
    UserComment: "User comment",
    UserDeleteFailed: "Failed to delete user",
    UserDeletedSuccessfully: "User deleted successfully",
    UserProfile: "User's profile",
    UsersByPlan: "Users by plan",
    View: "View",
    Welcome: "Welcome",
    WelcomeToTalkmate: "Welcome to TalkMate AI Bot",
    WelcomeToTicketHub: "Welcome to Talkmate",
    WelcomeToYourAIPlatform: "Overview of your AI agents and usage",
    WhoAreWe: "Who are we?",
    WhyChooseFeature1Desc: "Launch your AI agent in minutes with zero code.",
    WhyChooseFeature1Title: "Easy setup",
    WhyChooseFeature2Title: "Multi-channel support",
    WhyChooseFeature3Desc: "Start free and upgrade only when you grow.",
    WhyChooseFeature3Title: "Scalable pricing",
    WhyChooseTalkMate: "Why choose TalkMate?",
    WhyChooseTitle: "Why Choose Talkmate?",
    WithEmail: "With email",
    WorkingOnIt: "Working on it",
    WriteAMessage: "Ask your question...",
    WriteAMessageEmail: "Enter your email to start chatting...",
    WriteDescription: "DESCRIPTION OF THE ISSUE",
    WriteDescriptionError: "Ticket description",
    You: "You",
    YouArePremium: "You are Premium",
    YouAreSuspended: "Your account has been suspended",
    YourColleagues: "Your team members",
    YourUserProfil: "Your user profile",
    botIsWriting: "Thinking...",
    performedBy: "Done by:",
  },
  fr: {
    AboutHeroTitle: "Qui sommes-nous",
    AboutModelTitle: "Notre vision",
    AboutPageTitle: "À propos de Talkmate AI",
    AboutTalkMateTitle: "Qu’est-ce que TalkMate ?",
    Active: "Actif",
    ActiveAgents: "Agents actifs",
    AddAProject: "Ajouter un projet",
    AddComment: "Ajouter un commentaire",
    AddNewTicket: "Ajouter un ticket",
    AddProject: "Ajouter un projet",
    AdminComment: "Commentaire admin",
    AdminNoProjectsYet: "Aucun projet pour le moment",
    Agent: "Agent",
    AgentContext: "Contexte & persona",
    AgentContextHelp:
      "On récupère les infos clés et le ton de votre activité pour que l’agent réponde comme vous.",
    AgentDescription: "Description courte",
    AgentName: "Nom de l'agent",
    AgentNameHelp: "Donnez-lui un nom court et mémorisable. Vous pourrez le changer plus tard.",
    AgentWebsite: "URL du site web",
    AgentWebsiteHelp:
      "Indiquez l’adresse de votre site : nous irons chercher les infos principales pour pré-remplir l’agent.",
    AgentPresentationLabel: "Présentation de l'agent pour le client",
    AgentTone: "Ton",
    Agents: "Agents",
    AgentsLimitHelper: "Limite : {max} agents",
    AgentsLimitReached: "Vous avez atteint la limite gratuite ({max} agents).",
    All: "Tous",
    AllSubscriptions: "Tous les abonnements",
    AlreadyMemberOfACompany: "Cet utilisateur appartient déjà à une entreprise",
    Analytics: "Analyses",
    AreYouSureToDeleteTicket: "Etes vous sur de vouloir supprimer ce ticket ?",
    AttachedFiles: "FICHIER(S) JOINT(S)",
    AttachmentsSaved: "Pièces jointes enregistrées",
    AvailableOnPremium: "Disponible sur le forfait premium",
    Back: "Retour",
    Billing: "Facturation",
    Brand: "Talkmate",
    Branding: "Branding",
    Bug: "Anomalie",
    ButtonDemo: "Demandez une démo",
    Cancel: "Annuler",
    CancelNow: "Annuler à la fin de la période",
    CancelScheduled: "Annulation programmée",
    CancelSubscription: "Résilier l'abonnement",
    ChangeRequest: "Demande de changement",
    Channels: "Canaux",
    ChooseAProject: "Choisissez un projet",
    ClearReadNotifications: "Effacer les notifications lues",
    ClickToActivate: "Cliquer pour activer",
    ClickToDeactivate: "Cliquer pour désactiver",
    Close: "Fermer",
    Closed: "Fermé",
    ComingSoon: "En construction",
    CommaSeparated: "Séparé par des virgules",
    Company: "Société",
    CompleteYourProfile: "Quel est le nom de votre société ?",
    Confirm: "Valider",
    ConfirmDeleteTicket: "Etes vous sur de vouloir supprimer le ticket ?",
    ConfirmLogout: "Confirmer la déconnexion ?",
    ContactAdminsAt: "Merci de contacter l'administrateur à l'adresse ",
    ContactUs: "Contactez nous",
    ContinueWithoutEmail: "Continuer sans email",
    Conversations: "Conversations",
    ConversationsToday: "Conversations aujourd’hui",
    Create: "Créér",
    CreateAgent: "Créez votre agent",
    CreatedAt: "CREE LE",
    Creator: "CREE PAR",
    CurrentMonthTicketsCount: "Tickets créés ce mois-ci : {count}/40.",
    CurrentPlanLabel: "Votre plan actuel",
    Customer: "Client",
    DarkModeOff: "Dark Mode désactivé",
    DarkModeOn: "Dark Mode activé",
    Dashboard: "Statistiques",
    Delete: "Supprimer",
    DeleteAgentTitle: "Supprimer l’agent",
    DeleteTicket: "Supprimer le Ticket",
    Deleting: "Suppression...",
    DetailComingSoon: "On travaille dessus",
    Done: "Terminé",
    DragAndDropOrBrowse: "Glisser et déposer ou Sélectionner un fichier",
    Edit: "Editer",
    EditPicture: "Modifier la photo",
    EditProfile: "Informations du profil",
    EditProject: "Modifier le projet",
    EmailAddress: "Adresse email",
    EmailAlreadyExists: "Une invitation a déjà été envoyée à cet email",
    EmailAlreadyInvited: "Cet email a déjà été invité",
    EmailOptional: "Votre email (obligatoire pour démarrer)",
    EmailPlaceholder: "Votre email",
    ErrorDeletingTicket: "Problème lors de la suppression du ticket:",
    Evolution: "Évolution",
    FailedToAddTicket: "Échec de l’ajout du ticket",
    FailedToUpdateTicket: "Échec de la mise à jour du ticket",
    Feature: "Fonctionnalité",
    FeatureEase: "Création d’agents illimités en quelques minutes",
    FeaturePremiumValue: "Payez uniquement selon le nombre de questions posées",
    FeatureZeroCost: "10 questions offertes pour tester votre agent IA",
    FreePlanFeature1: "1 agent IA",
    FreePlanFeature2: "200 000 token offerts",
    FreePlanFeature3: "Lien public à partager avec vos clients",
    FreePlanTitle: "Offre gratuite",
    GetStartedByCreatingProject: "Commencez par créer un projet",
    GoPremium: "Passer premium",
    GoToDashboard: "Aller au tableau de bord",
    HelpCenterSubtitle: "Tout ce qu’il faut pour tirer le meilleur de TalkMate",
    HelpCenterTitle: "Aide & Ressources",
    HelpFAQs: "Aide & FAQs",
    HeroHighlight: "personnalisés",
    HeroImageAlt: "Aperçu du tableau de bord Ticketize",
    HeroTitleFull: "Créez vos propres agents IA pour votre entreprise",
    HeroTitlePart1: "Votre entreprise,",
    HeroTitlePart2: "vos agents IA",
    High: "Élevée",
    Improvement: "Amélioration",
    InProduction: "En production",
    InReview: "En revue",
    InStaging: "En recette",
    InTest: "En test",
    Inactive: "Inactif",
    Incident: "Incident",
    InitializingChat: "Initialisation du chat...",
    ChatEmailHint: "Entrez votre email pour démarrer le chat avec notre agent.",
    Integrations: "Intégrations",
    IntegrationsMetric: "Intégrations",
    Interactions: "Interactions",
    InvalidEmail: "Veuillez entrer une adresse email valide",
    InviteByEmail: "Inviter un utilisateur par email",
    InviteFailed: "Échec de l’envoi de l’invitation",
    InviteSent: "Invitation envoyée",
    InviteUser: "Invitez un utilisateur",
    JoinedOn: "Inscrit(e) le",
    Landing_BenefitsBanner: "Toujours disponible 24/7 • Toutes les langues • Réponses instantanées • Langage naturel • Plus besoin d’assurer les réponses immédiates",
    Landing_CTAPrimary: "Créer votre premier agent gratuitement",
    Landing_ExamplesHeading: "Exemples — Vous expliquez. L’agent répond.",
    Landing_FreeTrialLine: "Essayez gratuitement : 1 agent inclus, jusqu’à 10 questions",
    Landing_HeroSubtitle1: "En ligne, sur votre site, ou par lien direct.",
    Landing_HeroSubtitle2: "Il répond à la place de votre équipe aux questions récurrentes. Instantanément. 24/7.",
    Landing_HeroTitle: "Créez votre agent IA qui répond à vos clients automatiquement",
    Landing_HowStep1Desc: "Dites ce que fait votre activité et vos infos clés.",
    Landing_HowStep1Title: "1. Décrivez votre contexte",
    Landing_HowStep2Desc: "Posez des questions et ajustez en quelques secondes.",
    Landing_HowStep2Title: "2. Testez en direct",
    Landing_HowStep3Desc: "Ajoutez le widget ou partagez un lien simple.",
    Landing_HowStep3Title: "3. Partagez partout",
    Landing_HowTitle: "Comment ça marche",
    Landing_RealEstateMsg1Client: "Bonjour, où se situe exactement l’appartement rue Victor‑Hugo ?",
    Landing_RealEstateMsg2Agent: "À 5 minutes du métro et proche des commerces. L’adresse précise figure dans la fiche du bien.",
    Landing_RealEstateMsg3Client: "Le logement a‑t‑il un parking et quelles charges sont incluses ?",
    Landing_RealEstateMsg4Agent: "Parking en option. Eau comprise, électricité non incluse. Tous les détails sont dans la description.",
    Landing_RealEstateTitle: "Assistant Immobilier — Infos biens en direct",
    Landing_RestaurantMsg1Client: "Bonjour, quels sont vos horaires aujourd’hui ?",
    Landing_RestaurantMsg2Agent: "Nous sommes ouverts de 12h à 14h et de 19h à 22h.",
    Landing_RestaurantMsg3Client: "Avez‑vous des options végétariennes au menu ?",
    Landing_RestaurantMsg4Agent: "Oui, par exemple une salade de quinoa et un curry de légumes. La liste complète est dans notre carte.",
    Landing_RestaurantTitle: "Assistant Restaurant — FAQ instantanée",
    Landing_ValueCard1Desc: "1 agent inclus, jusqu’à 10 questions.",
    Landing_ValueCard1Title: "Essayez en 2 minutes",
    Landing_ValueCard2Desc: "Premium ensuite : agents illimités, paiement au volume.",
    Landing_ValueCard2Title: "Sans carte, sans engagement",
    LatestSupportTickets: "Derniers tickets postés",
    Loading: "Chargement…",
    LoadingUsers: "Chargement des utilisateurs...",
    LogInWithGoogle: "Se connecter avec Google",
    Logout: "Deconnexion",
    Low: "Faible",
    ManageAndMonitorAgents: "Créez, configurez et suivez vos agents IA",
    ManageFile: "Ajouter/retirer fichier(s)",
    ManageSubscription: "Gérer l'abonnement",
    MaxFileSize: "Taille max. de fichier : ",
    Medium: "Moyenne",
    MissingFields: "CHAMPS MANQUANTS",
    MonthlyRevenueEst: "Revenu mensuel (est.)",
    MonthlyRevenueHint: "Basé sur {count} comptes premium à 15 $/mois.",
    MonthlyUsage: "Consommation mensuelle",
    MyTickets: "Mes agents",
    NavOffer: "Notre offre",
    NewMessages: "Nouveaux messages",
    NewsletterCta: "S’abonner",
    NewsletterEmailPlaceholder: "Entrez votre email pour rester informé",
    NewsletterInvalidEmail: "Email invalide.",
    NewsletterSaveFailed: "Impossible d’enregistrer votre email. Réessayez.",
    NewsletterSubmitting: "Inscription…",
    NewsletterThanks: "Merci ! Vous êtes bien inscrit(e).",
    Next: "Suivant",
    NoActivityYet: "Pas encore d'activité",
    NoAgentsYet: "Aucun agent pour le moment",
    NoColleagues: "Personne de votre équipe pour le moment",
    NoEmail: "Sans email",
    NoHistory: "Aucune consommation historique",
    NoNotifications: "Aucune notification",
    NoProjectNormal: "Pas de projets pour le moment →",
    NoProjectSelected: "Aucun projet sélectionné",
    NoProjects: "Pas de projet créé pour le moment",
    NoTicketsInTab: "Pas de ticket pour ce statut pour ce projet",
    NoTicketsToShow: "Pas de ticket pour ce projet / Pas de projet sélectionné",
    NoUsersFound: "Aucun utilisateur trouvé",
    OfMonthlyBudget: "du total disponible mensuel",
    OnlyCreatorCanEdit: "Seul le créateur ou un admin peut modifier ce ticket",
    OnlyOneProjectOnFree: "Un seul projet est autorisé sur le plan gratuit.",
    Open: "Ouvert",
    OptionalMessage: "Message (facultatif)",
    OverviewTitle: "Vue d'ensemble",
    PageConcerned: "ELEMENT CONCERNE",
    PageListCategories: "Listes des types de pages",
    PaymentCanceledMessage: "Le paiement a été annulé. Vous pouvez réessayer.",
    PaymentCanceledTitle: "Paiement annulé",
    PaymentSuccessMessage: "Votre abonnement Premium est maintenant actif.",
    PaymentSuccessTitle: "Paiement réussi",
    Pending: "En attente",
    PhotoUploadFailed: "Échec du téléchargement de la photo",
    PlanBasicAgents: "Basic : 3 agents",
    PlanBasicTokens: "Basic : 200k jetons",
    PlanDetailsBasic: "Basic : 3 agents / 200k jetons par mois.",
    PlanDetailsPremium: "Premium : 15 agents / 2M jetons par mois.",
    PlanFreeHint: "Plan Basic : jusqu’à 3 agents / 200k jetons par mois.",
    PlanFreeLabel: "Offre Basic",
    PlanNoneLabel: "Aucun tenant",
    PlanPremiumAgents: "Premium : 15 agents",
    PlanPremiumHint: "Premium : jusqu’à 15 agents / 2M de jetons par mois.",
    PlanPremiumLabel: "Offre Premium",
    PlanPremiumTokens: "Premium : 2M jetons",
    PlanUnknownLabel: "Inconnu",
    PlanUpgradeCTA: "Passer au Premium",
    PleaseFillYourCompanyName: "Merci de saisir le nom de votre société",
    PleaseFillYourCompanyNameFirst: "Saisir d'abord le nom de votre société",
    PleaseSendTicket: "Merci de soumettre un ticket",
    PostComment: "Publier le commentaire",
    PremiumBadge: "Workspace Premium",
    PremiumBadgeSubtitle: "Débloquez toute la suite Talkmate",
    PremiumFeature1Title: "Agents brandés illimités",
    PremiumFeature2Desc: "",
    PremiumFeature2Title: "Automatisations avancées",
    PremiumFeature3Desc: "",
    PremiumFeature3Title: "Analyses détaillées",
    PremiumFeature4Title: "Partage & intégration partout",
    PremiumFeature5Desc: "",
    PremiumFeature5Title: "Contrôles entreprise",
    PremiumFeature6Desc: "",
    PremiumFeature6Title: "Equipe succès prioritaire",
    PremiumFeaturesEyebrow: "Capacités",
    PremiumHeroCTA: "Passer au Premium",
    PremiumHeroTalkToSales: "Parler à l'équipe",
    PremiumPageTitle: "Offre Premium",
    PremiumPlanCardTitle: "Ce que comprend le Premium",
    PremiumPlanFeature1: "Agents illimités avec contexte enrichi",
    PremiumPlanFeature2: "Modèles OpenAI avancés (GPT-4o)",
    PremiumPlanFeature3: "Analyses et historique des conversations",
    PremiumPlanFeature4: "Branding personnalisé du widget de chat",
    PremiumPlanIncluded1: "Agents IA et liens partagés illimités",
    PremiumPlanIncluded2: "",
    PremiumPlanIncluded3: "Accès à GPT-4o",
    PremiumPlanIncluded4: "",
    PremiumPlanIncluded5: "Historique des conversations",
    PremiumPlanIncluded6: "",
    PremiumPlanPrice: "$15",
    PremiumPlanPriceSuffix: "/mois",
    PremiumPlanTitle: "Offre Premium",
    PremiumStat1Label: "Widgets, liens & API",
    PremiumStat1Value: "Illimité",
    PremiumStat2Label: "De temps gagné sur les questions répétitives",
    PremiumStat2Value: "-70 %",
    PremiumStat3Label: "Capture de leads & support client",
    PremiumStat3Value: "24/7",
    PremiumWorkflow1Title: "Définissez le contexte de chaque agent",
    PremiumWorkflow2Title: "Testez et ajoutez des garde-fous",
    PremiumWorkflow3Title: "Diffusez partout",
    PremiumWorkflowTitle: "Lancement en quelques jours",
    PreviousMonths: "Mois précédents",
    Price: "Prix",
    Pricing: "Tarifs",
    PricingPageTitle: "Tarifs Talkmate – Gratuit vs. Premium",
    PricingPlansTitle: "Nos formules",
    PricingTitle: "Nos formules",
    Priority: "PRIORITEE",
    PriorityChanged: "Priorité modifiée",
    PriorityError: "Priorité",
    PriorityForm: "Priorité",
    PrivacyPolicy: "Politique de confidentialité",
    PrivacyPolicyTitle: "Politique de confidentialité",
    Problem: "Problème",
    Profile: "Profil",
    Project: "PROJET",
    ProjectCreated: "Project created",
    ProjectDeletedConfirm: "Êtes‑vous sûr de vouloir supprimer ce projet ?",
    ProjectMembers: "Membres du projet",
    ProjectName: "Nom du projet",
    ProjectUpdated: "Projet mis à jour avec succès",
    Projects: "Projets",
    ProjectsList: "LISTE DES PROJETS",
    Question: "Question",
    QuestionsThisMonth: "Questions ce mois-ci",
    QuestionsUsed: "Questions utilisées",
    RecentAgents: "Agents récents",
    RemainingCredits: "Crédits restants",
    RemoveLogo: "Supprimer le logo",
    RenewSubscription: "Renouveler l'abonnement",
    RequiredField: "Champ obligatoire",
    Reset: "Réinitialiser",
    ResetTest: "Réinitialiser le test",
    RoleUpdateFailed: "Échec de la mise à jour du rôle",
    RoleUpdated: "Rôle mis à jour avec succès",
    Save: "Enregistrer",
    SaveAttachments: "Mettre à jour",
    SearchPlaceholder: "Rechercher…",
    Select: "Sélectionnez",
    SelectMembers: "Sélectionnez le(s) membre(s)",
    SelectProject: "Veuillez sélectionner un projet",
    SelectTone: "Sélectionner un ton",
    Send: "Envoyer",
    SendAMessage: "Envoyer un message",
    SendEmail: "Envoyer un email",
    SendInvite: "Envoyer l'invitation",
    SignIn: "Se connecter",
    Signout: "Déconnexion",
    Start: "Commencer",
    Status: "STATUT",
    StatusChangedClosed: "Statut → Fermé",
    StatusChangedOpen: "Statut → Ouvert",
    Subscription: "Abonnement",
    SubscriptionCanceledTitle: "Abonnement annulé",
    SuccessfullyLoggedInWithGoogle: "Connecté via Google avec succès",
    Suggestion: "Suggestion",
    SuperAdminTitle: "Super Admin",
    SupportTickets: "Tickets de support",
    Task: "Tâche",
    TeamMembers: "MEMBRE(S) DE L'EQUIPE",
    TestChat: "Tester le chat",
    ThisMonth: "Ce mois-ci",
    TicketActivity: "Activité du ticket",
    TicketAddedSuccessfully: "Ticket ajouté avec succès",
    TicketCreated: "Ticket créé",
    TicketInsights: "Ticket Insights",
    TicketName: "NOM DU TICKET",
    TicketNameError: "Nom du ticket",
    TicketNameForm: "Nom du ticket",
    TicketNumber: "# TICKET ",
    TicketSuccessfullyDeleted: "Ticket supprimé avec succès",
    TicketType: "TYPE DE TICKET",
    TicketTypeError: "Type du ticket",
    TicketUpdatedSuccessfully: "Ticket mis à jour avec succès",
    TierFreeButton: "Essayer gratuitement",
    TierFreeFeature1: "1 agent IA de test",
    TierFreeFeature2: "200 000 tokens offerts",
    TierFreeFeature3: "Configuration de contexte basique",
    TierFreeFeature4: "Lien public à partager",
    TierFreeFeature5: "Support communautaire",
    TierFreeName: "Gratuit",
    TierFreePrice: "0",
    TierPremiumButton: "Passer au Premium",
    TierPremiumFeature1: "Agents IA illimités",
    TierPremiumFeature2: "Facturation au nombre de questions posées",
    TierPremiumFeature3: "Accès aux modèles avancés (GPT-4o & GPT-4.1)",
    TierPremiumFeature4: "Historique et analyses de conversations",
    TierPremiumFeature5: "Branding et intégrations personnalisés",
    TierPremiumFeature6: "Support prioritaire",
    TierPremiumName: "Premium",
    TierPremiumPrice: "20",
    Tokens: "Jetons utilisés",
    TokensLimitHelper: "Quota mensuel : {max}",
    ToneConcise: "Concis",
    ToneEmpathetic: "Empathique",
    ToneFriendly: "Amical",
    ToneLabel: "Ton",
    ToneNeutral: "Neutre",
    TonePlayful: "Ludique",
    ToneProfessional: "Professionnel",
    ToneSupportive: "Bienveillant",
    ToneTechnical: "Technique",
    TotalTokensAllTenants: "Total de jetons (tous tenants)",
    TotalTokensUsed: "Jetons utilisés",
    TryAgain: "Réessayer",
    Type: "TYPE",
    UnreadConversations: "Conversations non lues",
    UpdateTicket: "Mise à jour du ticket",
    UploadFiles: "Télécharger le(s) fichier(s)",
    UploadLogo: "Téléverser un logo",
    UserComment: "Commentaire utilisateur",
    UserDeleteFailed: "Échec de la suppression de l’utilisateur",
    UserDeletedSuccessfully: "Utilisateur supprimé avec succès",
    UserProfile: "Profil utilisateur",
    UsersByPlan: "Utilisateurs par plan",
    View: "Voir",
    Welcome: "Bienvenue",
    WelcomeToTalkmate: "Bienvenue sur TalkMate",
    WelcomeToTicketHub: "Bienvenue sur Talkmate",
    WelcomeToYourAIPlatform: "Vue d’ensemble de vos agents IA et de l’usage",
    WhoAreWe: "Qui sommmes nous?",
    WhyChooseFeature1Title: "IA sur mesure",
    WhyChooseFeature2Title: "Partage simplifié",
    WhyChooseFeature3Title: "Évolutif",
    WhyChooseTalkMate: "Pourquoi choisir TalkMate ?",
    WhyChooseTitle: "Pourquoi choisir Talkmate ?",
    WithEmail: "Avec email",
    WorkingOnIt: "En cours",
    WriteAMessage: "Posez votre question...",
    WriteAMessageEmail: "Saisissez votre email pour commencer à discuter...",
    WriteDescription: "DESCRIPTION DU PROBLEME",
    WriteDescriptionError: "Description du ticket",
    You: "Vous",
    YouArePremium: "Vous êtes Premium",
    YouAreSuspended: "Votre compte a été suspendu",
    YourColleagues: "Membres de l'équipe",
    YourUserProfil: "Votre profil utilisateur",
    botIsWriting: "Rédige...",
    performedBy: "Traité par:",
  },
};
